import React from "react"
import {useNavigate} from "react-router-dom"
// MUI
import {Box, Button, Typography} from "@mui/material"
import {ChevronRight, TuneRounded} from "@mui/icons-material"
// Layout
import {PageHeader, SectionCard} from "@/components/Layout"
// Theme
import {packagingTokens as tk} from "@/theme/packagingTokens"
// Translation
import {useTranslation} from "react-i18next"

// The packaging Settings section. One card per setting; each opens a dedicated
// configuration page. Filters propagation is the first.
export default function SettingsTab() {
    const {t} = useTranslation(["common"])
    const redirect = useNavigate()

    const settings = [
        {
            id: "filters-propagation",
            icon: <TuneRounded sx={{fontSize: 20, color: tk.color.textSecondary}} />,
            title: t("settings_filters_propagation"),
            description: t("settings_filters_propagation_description"),
            to: "/settings/filters-propagation",
        },
    ]

    return (
        <Box>
            <PageHeader title={t("nav_settings")} subtitle={t("settings_subtitle")} />

            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                {settings.map((setting) => (
                    <SectionCard key={setting.id} icon={setting.icon} title={setting.title}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 2,
                                flexWrap: "wrap",
                            }}
                        >
                            <Typography sx={{fontSize: "13px", color: tk.color.textSecondary, maxWidth: 620}}>
                                {setting.description}
                            </Typography>
                            <Button
                                variant={"outlined"}
                                disableElevation
                                endIcon={<ChevronRight sx={{fontSize: 18}} />}
                                onClick={() => redirect(setting.to)}
                                sx={{
                                    textTransform: "none",
                                    fontWeight: 600,
                                    borderRadius: tk.radius.sm,
                                    px: 2,
                                    flexShrink: 0,
                                }}
                            >
                                {t("configure")}
                            </Button>
                        </Box>
                    </SectionCard>
                ))}
            </Box>
        </Box>
    )
}
